import { Lesson } from '../service/lesson-service';
import dayjs from 'dayjs';

/**
 * 有効なレッスンか
 * @param lesson
 * @returns
 */
export const isValidLesson = (lesson: Lesson): boolean => {
  const now = dayjs();
  const d = new Date(lesson.endDatetime);
  const end = dayjs(lesson.endDatetime); // endDatetimeにはISO8601形式の日時が入ってくるため、UTCと認識
  const isBefore = now.isBefore(end);
  return isBefore;
};
